import GameBlock from './GameBlock';

export default GameBlock;
